import { useEffect, useRef, useState } from "react";
import {
  Enum_ValidationString,
  capitalizeFormat,
  checkCardIsSelected,
  checkNumCharactersNameAndSurname,
  checkValidationRequiredString,
  clearStringData,
  downloadFileFromBlob,
  exitFromApplication,
  goTo,
  removeLocalStorageAfterChangeCard,
  returnCardInfo,
  setSelectedCard,
  setSelectedCatalog,
} from "../../utilities/common.utilities";
import profileModel from "../../static/profile.model";
import { getUserProfile } from "../../service/profile.service";
import { Dropdown } from "primereact/dropdown";
import { getUserCards } from "../../service/card.service";
import cardModel from "../../static/card-model";
import { Button } from "primereact/button";
import { getAllCustomerInfo_Menu } from "../../service/allCustomerInfo.service";
import allInfoProfileModel from "../../static/allProfileInfo.model";
import LoadingSpinner from "../loading-spinner/loading-spinner";
import AssociateCard, {
  associateCardOutputModel,
} from "../AssociateCard/associateCard";
import { Dialog } from "primereact/dialog";
import ShareComponent from "../Share/share.component";
import { getPrivacyDocumentWithoutInterceptor } from "../../service/privacyDoc.service";
import { LoadError, SpecialZoomLevel, ViewMode, Viewer } from "@react-pdf-viewer/core";
import { Worker } from "@react-pdf-viewer/core";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import {
  EditAccount,
  editAccount,
} from "../../service/editAccountInfo.service";
import { changeAccountPassword } from "../../service/changeAccountPassword.service";
import { getCatalogs } from "../../service/catalog.service";
import {
  getPrivacyInfo,
  getPrivacyProfile,
} from "../../service/privacy.service";
import {
  ManagePrivacyDataModel,
  PrivacyInfoModel,
  PrivacyProfileModel,
} from "../../static/privacy.model";

import "./Menu-style.css";
import {
  MAXLENGTH_EMAIL,
  MAXLENGTH_NAME,
  MAXLENGTH_PASSWORD,
  MAXLENGTH_SURNAME,
} from "../../static/constants";
import {installPWA, onClickInstallButton, pwaInstalled} from "../../utilityPWA";
import PopupInstallComponent from "../PopupInstall/popupInstall.component";
import { isIOS } from "react-device-detect";
import { Toast } from "primereact/toast";
import { useConnectivity } from "../../context/connectivityContext";
import { getPharmacyInfoWithoutInterceptor } from "../../service/pharmacy.service";
import { renderErrorViewerPdf } from "../../utilities/pdf-viewer.utilities";
import { useLocation } from "react-router-dom";
import { getRewards } from "../../service/reward.service";

type CardList = {
  groupName: string;
  storeName: string;
  value: string;
  customer: string;
};

type InfoSelectedCard = {
  groupCode: string;
  storeCode: string;
};

type InputInfoStatus = {
  value: string;
  valid: boolean;
  showError: boolean;
  editValue: string;
};

type Theme = "dark" | "high-contrast" | "light-blue";

export default function MenuComponent( { 
  onThemeChange, 
  currentTheme,
  themeChanged 
}: { 
  onThemeChange: (theme: Theme) => void; 
  currentTheme: Theme;
  themeChanged: boolean 
}) {

  const defaultInfoStatus: InputInfoStatus = {
    value: "",
    valid: false,
    showError: false,
    editValue: "",
  };
  const [user, setUser] = useState<profileModel>({
    email: "",
    firstName: "",
    lastName: "",
    signInName: "",
  });
  const toast = useRef<Toast>(null);
  const location = useLocation();
  
  const [cardList, setCardList] = useState<CardList[]>([]);
  const [selectedCard, setCard] = useState<string>("");
  const [infoSelectedCard, setInfoSelectedCard] = useState<InfoSelectedCard>({
    groupCode: "",
    storeCode: "",
  });
  const [allProfileInfo, setAllprofileInfo] = useState<allInfoProfileModel>();
  const [loadingGetPdfPrivacy, setLoadingGetPdfPrivacy] =
    useState<boolean>(false);
  const [showLoader, setShowLoader] = useState<boolean>(true);
  const [showSharingComponent, setShowSharingComponent] =
    useState<boolean>(false);
  const [showLegalInfo, setShowLegalInfo] = useState<boolean>(false);
  const [showCondizioniUtilizzo, setShowCondizioniUtilizzo] =
    useState<boolean>(false);
  const [showEditMode, setShowEditMode] = useState<boolean>(false);
  const [showConfig, setShowConfig] = useState<boolean>(false);
  const [showThemeSelector, setShowThemeSelector] = useState<boolean>(false);

  const [theme, setTheme] = useState<string>(localStorage.getItem("theme") || "light-blue");
  const [dialogKey, setDialogKey] = useState<number>(0);

  const [loadingGetCustomer, setloadingGetCustomer] = useState<boolean>(true);
  const [name, setName] = useState<InputInfoStatus>(defaultInfoStatus);
  const [surname, setSurname] = useState<InputInfoStatus>(defaultInfoStatus);
  const [checkCharsNameSurname, setCheckCharsNameSurname] =
    useState<boolean>(true);
  const [email, setEmail] = useState<InputInfoStatus>(defaultInfoStatus);
  const [matchEmail, setMatchEmail] =
    useState<InputInfoStatus>(defaultInfoStatus);
  const [viewMatchEmail, setViewMatchEmail] = useState<boolean>(false);
  const [password, setPassword] = useState<InputInfoStatus>(defaultInfoStatus);
  const [matchPassword, setMatchPassword] =
    useState<InputInfoStatus>(defaultInfoStatus);
  const [changePassword, setChangePassword] = useState<boolean>(false);
  const [hideChangePassword, setHideChangePassword] = useState<boolean>(false);
  const [popupSuccessVisible, setPopupSuccessVisible] = useState(false);

  const { isOnline } = useConnectivity();

  const handleThemeChange = (theme: Theme) => {
    onThemeChange(theme); // Passa il tema selezionato al genitore
    setShowThemeSelector(false); // Chiudi il popup
    setTheme(theme);      // Aggiorna il tema locale (se usato per le classi CSS)
  };

  const footerContent = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => {
          setPopupSuccessVisible(false);
          setShowEditMode(false);
          setChangePassword(false);
          setHideChangePassword(false);
          setViewMatchEmail(false);
          setShowFormAddCard(false);
          localStorage.removeItem("GET_PROFILE_TIME");
          localStorage.removeItem("profile");
          getProfile();
        }}
        autoFocus
      />
    </div>
  );
  const [showFormAddCard, setShowFormAddCard] = useState<boolean>(false);
  const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);
  const [disableCloseButton, setDisableCloseButton] = useState<boolean>(false);
  

  const ShowCard = () => {
    document.getElementById("cardselector")?.click();
  };

  const getCards = (storeCodeCheckPrivacy?: string) => {
    setShowLoader(true);
    getUserCards().then((cardData: cardModel) => {
      if (cardData?.cards.length > 0) {
        let temp_cardList = cardData.cards.map((x) => {
          return {
            groupName: x.groupName,
            storeName: x.mainStoreName,
            value: x.cardNumber,
            customer: x.customerName,
          } as CardList;
        });
        setCardList(temp_cardList);

        if(storeCodeCheckPrivacy){
          let newCards = cardData.cards.find( x=> x.mainStoreCode === storeCodeCheckPrivacy )

          setSelectedCard(newCards!.cardNumber);
          setCard(newCards!.cardNumber);
          onSetCard(newCards!.groupId.toString(), newCards!.mainStoreCode, newCards!.cardNumber);
  
          getPharmacyInfoWithoutInterceptor(newCards!.groupId.toString(), newCards!.mainStoreCode, newCards!.cardNumber);
          
          onChangeCard(newCards!.cardNumber , false)

        }


        

        if(cardData?.cards.length === 1 ){
          const groupCode = cardData.cards[0].groupId.toString();
          const storeCode = cardData.cards[0].mainStoreCode;
          const card = cardData.cards[0].cardNumber;
          setSelectedCard(card);
          setCard(card);
          onSetCard(groupCode, storeCode, card);

          getPharmacyInfoWithoutInterceptor(groupCode, storeCode, card);

          if(storeCodeCheckPrivacy){
            // onChangeCard(card, false)
            localStorage.setItem('firstCardAdded', 'true' )
          }

        }else if (checkCardIsSelected() ) {
          returnCardInfo().then((card) => {
            setCard(card.card);
            onSetCard(card.groupCode, card.storeCode, card.card);
          });
        }else {
          const groupCode = cardData.cards[0].groupId.toString();
          const storeCode = cardData.cards[0].mainStoreCode;
          const card = cardData.cards[0].cardNumber;
          setSelectedCard(card);
          setCard(card);
          onSetCard(groupCode, storeCode, card);
        }

        // Ottenute le card, se bisogna aggiornare i consensi di privacy, recupero la card associata alla farmacia su cui è stata
        // aggiunta una card e ne recupero lo stato dei consensi

        if (storeCodeCheckPrivacy) {
          // recupero la card
          let cardCheck = cardData.cards.find(
            (c) => c.mainStoreCode === storeCodeCheckPrivacy
          );
          if (cardCheck) {
            checkMustUpdatePrivacy(
              cardCheck.groupId.toString(),
              cardCheck.mainStoreCode,
              cardCheck.cardNumber
            );
          }
        }
      }
      else {
        setCardList([]);
      }      
    });
  };

  const onSetCard = (
    groupCode: string,
    storeCode: string,
    selectedCard: string
  ) => {
    setShowLoader(true);

    let newInfoCard: InfoSelectedCard = {
      groupCode: groupCode,
      storeCode: storeCode,
    };

    setInfoSelectedCard(newInfoCard);
    setloadingGetCustomer(true);
    getAllCustomerInfo_Menu(groupCode, storeCode, selectedCard)
      .then((allCustomerInfo) => {
        const profile: allInfoProfileModel = allCustomerInfo?.profile;
        setAllprofileInfo(profile);
        setShowLoader(false);
        setloadingGetCustomer(false);
      })
      .catch(() => {
        setloadingGetCustomer(false);
      });
  };

  const onChangeCard = (card: string, checkPrivacy: boolean = true) => {

    if(navigator.onLine) {
      removeLocalStorageAfterChangeCard();
      setCard(card);
      setSelectedCard(card);
      returnCardInfo().then((cardInfo) => {
        setCard(cardInfo.card);
        onSetCard(cardInfo.groupCode, cardInfo.storeCode, cardInfo.card);
        localStorage.setItem("cardChanged", "true")
        getCatalogs(cardInfo.groupCode, cardInfo.storeCode, cardInfo.card).then(
          async (catalogs) => {
            if (catalogs?.length > 0) {
              setSelectedCatalog(catalogs[0].catalogId);
              if(localStorage.getItem('previousPath') === '/rewards-points'){
                getRewards(cardInfo.groupCode, cardInfo.storeCode, cardInfo.card, catalogs[0].catalogId)
              }
              return catalogs[0].catalogId.toString();
            } else {
              return "";
            }
            
          }
        );

        // Per avere sempre il codice a barra della card, richiamo anche la 'cardFiltered'
        getPharmacyInfoWithoutInterceptor(cardInfo.groupCode, cardInfo.storeCode, cardInfo.card);

        if(checkPrivacy){
          // Caricati tutti i dati, controllo se bisogna aggiornare i consensi della privacy
          checkMustUpdatePrivacy(
            cardInfo.groupCode,
            cardInfo.storeCode,
            cardInfo.card
          );
        }
      });
    }
    else {
      let message: string = 'Per eseguire il cambio della card, bisogna essere connessi ad Internet.';
      toast.current?.show({ severity: 'error', summary: 'Attenzione', detail: message });
    }
  };

  const getProfile = () => {
    getUserProfile().then((profile: profileModel) => {
      let result = profile;
      if (result) {
        setUser(result);
        setName({
          value: profile.firstName,
          valid: profile.firstName ? true : false,
          showError: false,
          editValue: profile.firstName,
        });
        setSurname({
          value: profile.lastName,
          valid: profile.lastName ? true : false,
          showError: false,
          editValue: profile.lastName,
        });
        // setPhone({
        //   value: "",
        //   valid: false,
        //   showError: false,
        //   editValue: "",
        // });
        setEmail({
          value: profile.email,
          valid: profile.email ? true : false,
          showError: false,
          editValue: profile.email,
        });
        setMatchEmail({
          value: "",
          valid: false,
          showError: false,
          editValue: "",
        });
      } else {
        setUser({
          email: "",
          firstName: "",
          lastName: "",
          signInName: "",
        });
      }
      setShowLoader(false);
    });
  };


  useEffect(() => {
    const storedTheme = localStorage.getItem("theme") || "light-blue";
    setTheme(storedTheme);
    if (showThemeSelector) {
      setDialogKey(Date.now());
    }

    let disableCloseButton: boolean = localStorage.getItem('necessaryActionMenu') === "true";
    setDisableCloseButton(disableCloseButton)

    getCards();
    getProfile();

    if(disableCloseButton) {
      setShowEditMode(true);
      setShowFormAddCard(true);
      setHideChangePassword(true);
    }

  }, [isOnline, showThemeSelector]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore


  const itemTemplate = (option: CardList) => {
    return (
      <div className="grid">

        <div className="col-1">
          <div className="flex align-items-center justify-content-center h-full">
            {selectedCard === option.value ? (
              <i
                className="pi pi-check text-secondary pr-1"
                style={{ fontSize: "1rem" }}
              ></i>
            ) : (
              <i className=""></i>
            )}
          </div>
        </div>

        <div className="col-10 flex align-items-center justify-content-center">
          <div className="flex flex-column justify-content-center">
      
          {
            option.groupName === option.storeName
            ?

            <div style={{ whiteSpace: "normal", textAlign: 'center' }}>
              {option.groupName}
            </div>

            :
            <>
              <div style={{ whiteSpace: "normal", textAlign: 'center' }}>
                {option.storeName}
              </div>

              <div style={{ whiteSpace: "normal", textAlign: 'center' }} className="my-2">
                <small>Gruppo: </small>
                <i> { option.groupName } </i>
              </div>
            </>
          }

          <div className="flex align-items-center justify-content-center w-full">
            {"( " + option.customer + " )"}
          </div>
          </div>
        </div>

        <div className="col-1"></div>
      </div>
    );
  };

  const downloadPdfPrivacy = () => {
    if (infoSelectedCard?.groupCode && !loadingGetPdfPrivacy) {
      setLoadingGetPdfPrivacy(true);

      getPrivacyDocumentWithoutInterceptor(
        infoSelectedCard.groupCode,
        infoSelectedCard.storeCode,
        selectedCard
      ).then((data_base64) => {
        if(data_base64) {
          
          const myBuffer = Uint8Array.from(atob(data_base64), (c) =>
            c.charCodeAt(0)
          );
          let file = new Blob([myBuffer], {
            type: "application/pdf;charset=utf-8",
          });

          let now: Date = new Date();
          let nomeFile: string = 'InformativaPrivacy_' + now.getFullYear() + '_' + now.getMonth() + '_' + now.getDate();
          downloadFileFromBlob(file, nomeFile)

        }

        else {
          let message: string = 'Per scaricare il file PDF, bisogna essere connessi ad internet.';
          toast.current?.show({ severity: 'error', summary: 'Attenzione', detail: message });
        }


        setLoadingGetPdfPrivacy(false);
      });
    }
  };

  // Funzione richiamata al click dell' elemento "Gestione consensi"
  const updatePrivacy = async () => {
    await getPrivacyProfile(
      infoSelectedCard.groupCode,
      infoSelectedCard.storeCode,
      selectedCard
    ).then((privacy: PrivacyProfileModel | null) => {
      if (privacy) {
        let state: ManagePrivacyDataModel = {
          pathname: "/menu",
          privacyInfo: privacy,
          forceUpdate: false,
          storeName: "-",
        };

        localStorage.setItem("managePrivacyData", JSON.stringify(state));
       // localStorage.setItem("previousPath", location.pathname )
        goTo("/privacy");
      }
    });
  };

  // Funzione utilizzata all' aggiungi carta o al cambio della carta
  async function checkMustUpdatePrivacy(
    groupCode: string,
    storeCode: string,
    card: string
  ) {
    localStorage.removeItem("GET_PRIVACY_PROFILE");
    localStorage.removeItem("getPrivacyProfile");

    await getPrivacyInfo(groupCode, storeCode, card).then(
      (privacy: PrivacyInfoModel | null) => {
        if (privacy && privacy.forcePrivacySet) {
          let state: ManagePrivacyDataModel = {
            pathname: "/menu",
            privacyInfo: privacy.privacyProfile,
            forceUpdate: true,
            storeName: "-",
          };

          localStorage.setItem("managePrivacyData", JSON.stringify(state));
          goTo("/privacy");
        }
      }
    );
  }

  function onChangeName(nameValue: string): void {
    nameValue = nameValue ? capitalizeFormat(nameValue) : "";
    nameValue = clearStringData(nameValue, false);

    let nameInfo: InputInfoStatus = {
      value: user.firstName,
      valid: checkValidationRequiredString(
        nameValue,
        Enum_ValidationString.Any
      ),
      showError: name.showError,
      editValue: nameValue,
    };

    let validTotCharsNameSurname: boolean = checkNumCharactersNameAndSurname(
      nameValue,
      surname.editValue
    );
    setCheckCharsNameSurname(validTotCharsNameSurname);
    setName(nameInfo);
  }

  function onBlurName() {
    let nameValue = clearStringData(name.editValue, true);

    let blurNameInfo: InputInfoStatus = {
      value: nameValue,
      valid: checkValidationRequiredString(
        nameValue,
        Enum_ValidationString.Any
      ),
      showError: name.showError,
      editValue: nameValue,
    };
    blurNameInfo.showError = true;
    setName(blurNameInfo);
  }

  function onChangeSurname(surnameValue: string): void {
    surnameValue = surnameValue ? capitalizeFormat(surnameValue) : "";
    surnameValue = clearStringData(surnameValue, false);

    let surnameInfo: InputInfoStatus = {
      value: user.lastName,
      valid: checkValidationRequiredString(
        surnameValue,
        Enum_ValidationString.Any
      ),
      showError: surname.showError,
      editValue: surnameValue,
    };

    let validTotCharsNameSurname: boolean = checkNumCharactersNameAndSurname(
      name.editValue,
      surnameValue
    );
    setCheckCharsNameSurname(validTotCharsNameSurname);
    setSurname(surnameInfo);
  }
  function onBlurSurname() {
    let surnameValue: string = clearStringData(surname.editValue, true);

    let blurSurnameInfo: InputInfoStatus = {
      value: surnameValue,
      valid: checkValidationRequiredString(
        surnameValue,
        Enum_ValidationString.Any
      ),
      showError: surname.showError,
      editValue: surnameValue,
    };
    blurSurnameInfo.showError = true;
    setSurname(blurSurnameInfo);
  }

  // function onChangePhone(telefono: string | null) {
  //   let phoneInput: string = telefono ? telefono.toString() : "";
  //   let phoneInfo: InputInfoStatus = {
  //     value: "",
  //     valid: checkValidationRequiredString(
  //       phoneInput,
  //       Enum_ValidationString.NumberCode
  //     ),
  //     showError: phone.showError,
  //     editValue: "",
  //   };
  //   // telefonoInput.replace("_", "").replace("-", "");
  //   setPhone(phoneInfo);
  //   checkValidationRequiredString(phoneInput, Enum_ValidationString.NumberCode);
  //   // checkValidatorTelefono(telefonoInput);
  // }
  // function onBlurPhone() {
  //   let blurPhoneInfo: InputInfoStatus = {
  //     value: phone.value,
  //     valid: checkValidationRequiredString(
  //       phone.value,
  //       Enum_ValidationString.NumberCode
  //     ),
  //     showError: phone.showError,
  //     editValue: "",
  //   };
  //   blurPhoneInfo.showError = true;
  //   setPhone(blurPhoneInfo);
  // }
  function onChangeEmail(emailValue: string) {
    emailValue = emailValue ? emailValue.toLowerCase() : "";
    // per l' email rimuovo tutti gli spazi
    emailValue = emailValue.replaceAll(" ", "");

    let checkMatchEmail: boolean = checkValidationRequiredString(
      matchEmail.value,
      Enum_ValidationString.Email,
      emailValue
    );
    setViewMatchEmail(true);
    let EmailInfo: InputInfoStatus = {
      value: user.email,
      valid: checkValidationRequiredString(
        emailValue,
        Enum_ValidationString.Email
      ),
      showError: email.showError,
      editValue: emailValue,
    };
    setEmail(EmailInfo);
    checkValidationRequiredString(emailValue, Enum_ValidationString.Email);
    setMatchEmail({
      value: matchEmail.value,
      valid: checkMatchEmail,
      showError: matchEmail.showError,
      editValue: matchEmail.editValue,
    });
  }
  function onBlurEmail() {
    let blurEmail: InputInfoStatus = {
      value: email.value,
      valid: checkValidationRequiredString(
        email.editValue,
        Enum_ValidationString.Email
      ),
      showError: email.showError,
      editValue: email.editValue,
    };
    blurEmail.showError = true;
    setEmail(blurEmail);
  }

  function onChangeMatchEmail(valueEmail: string) {
    valueEmail = valueEmail ? valueEmail.toLowerCase() : "";
    // per l' email rimuovo tutti gli spazi
    valueEmail = valueEmail.replaceAll(" ", "");

    let matchEmailInfo: InputInfoStatus = {
      value: matchEmail.editValue,
      valid: checkValidationRequiredString(
        valueEmail,
        Enum_ValidationString.Email,
        email.editValue
      ),
      showError: email.showError,
      editValue: valueEmail,
    };
    setMatchEmail(matchEmailInfo);
  }
  function onBlurMatchEmail() {
    let blurMatchEmail: InputInfoStatus = {
      value: matchEmail.editValue,
      valid: checkValidationRequiredString(
        matchEmail.editValue,
        Enum_ValidationString.Email,
        email.editValue
      ),
      showError: matchEmail.showError,
      editValue: matchEmail.editValue,
    };
    blurMatchEmail.showError = true;
    setMatchEmail(blurMatchEmail);
  }
  function getErrorEmail(): string {
    let messageError: string = "";
    if (!email.valid) {
      if (email.value.length === 0) {
        messageError = "Campo obbligatorio";
      } else {
        messageError = "Indirizzo email non valido";
      }
    }

    return messageError;
  }

  function getErrorMatchEmail(): string {
    let messageErrorEmail: string = "";

    if (matchEmail.editValue !== email.editValue) {
      messageErrorEmail = "L'email non corrisponde";
    } else {
      messageErrorEmail = "";
    }
    return messageErrorEmail;
  }

  function onChangePassword(passwordValue: string) {
    // per la password rimuovo tutti gli spazi
    passwordValue = passwordValue ? passwordValue.replaceAll(" ", "") : "";

    let checkMatchPsw: boolean = checkValidationRequiredString(
      matchPassword.value,
      Enum_ValidationString.Password,
      passwordValue
    );
    let passwordInfo: InputInfoStatus = {
      value: password.editValue,
      valid: checkValidationRequiredString(
        passwordValue,
        Enum_ValidationString.Password
      ),
      showError: password.showError,
      editValue: passwordValue,
    };
    setPassword(passwordInfo);
    checkValidationRequiredString(
      passwordValue,
      Enum_ValidationString.Password
    );
    setMatchPassword({
      value: matchPassword.value,
      valid: checkMatchPsw,
      showError: matchPassword.showError,
      editValue: matchPassword.editValue,
    });
    //checkValidatorPassword(password);
  }
  function onBlurPassword() {
    let blurPasswordInfo: InputInfoStatus = {
      value: password.value,
      valid: checkValidationRequiredString(
        password.editValue,
        Enum_ValidationString.Password
      ),
      showError: password.showError,
      editValue: password.editValue,
    };
    blurPasswordInfo.showError = true;
    setPassword(blurPasswordInfo);
  }

  function onChangeMatchPassword(valuePassword: string) {
    // per la password rimuovo tutti gli spazi
    valuePassword = valuePassword ? valuePassword.replaceAll(" ", "") : "";

    let matchPasswordInfo: InputInfoStatus = {
      value: matchPassword.editValue,
      valid: checkValidationRequiredString(
        valuePassword,
        Enum_ValidationString.Password,
        password.editValue
      ),
      showError: matchPassword.showError,
      editValue: valuePassword,
    };
    setMatchPassword(matchPasswordInfo);
    checkValidationRequiredString(
      valuePassword,
      Enum_ValidationString.Password,
      password.editValue
    );
  }

  function onBlurMatchPassword() {
    let blurMatchPassword: InputInfoStatus = {
      value: matchPassword.editValue,
      valid: checkValidationRequiredString(
        matchPassword.editValue,
        Enum_ValidationString.Password,
        password.editValue
      ),
      showError: matchPassword.showError,
      editValue: matchPassword.editValue,
    };
    blurMatchPassword.showError = true;
    setMatchPassword(blurMatchPassword);
  }

  function getErrorMatchPassword(): string {
    let messageErrorPassword: string = "";

    if (matchPassword.editValue !== password.editValue) {
      messageErrorPassword = " La password non corrisponde ";
    } else {
      messageErrorPassword = "Campo obbligatorio";
    }
    return messageErrorPassword;
  }

  // Controlla la validità dei campi
  function isFormValid(): boolean {
    return (
      checkCharsNameSurname &&
      isChangedDataForm() &&
      name.valid &&
      surname.valid &&
      (viewMatchEmail
        ? email.valid &&
        matchEmail.valid &&
        email.editValue === matchEmail.editValue
        : true)
    );
  }

  // Controlla se i valori immessi sono diversi da quelli originali
  function isChangedDataForm(): boolean {
    return (
      user.firstName !== name.editValue ||
      user.lastName !== surname.editValue ||
      email.editValue !== email.value ||
      viewMatchEmail
    );
  }

  function isPasswordValid() {
    return password.valid && matchPassword.valid;
  }

  function editAccountDate() {
    if (isFormValid()) {
      let request: EditAccount = {
        firstName: name.editValue,
        lastName: surname.editValue,
        email: email.editValue,
      };
      editAccount(request).then((x) => {
        if (x === "OK") {
          setPopupSuccessVisible(true);
        } else {
          setPopupSuccessVisible(false);
        }
      });
    } else {
    }
  }

  function editPassword() {
    if (isPasswordValid()) {
      changeAccountPassword(password.editValue).then((x) => {
        if (x === "OK") {
          setPopupSuccessVisible(true);
        } else {
          setPopupSuccessVisible(false);
        }
      });
    }
  }


  // function onClickCloseButton(): void {
  //   if(!disableCloseButton) {
  //     if(localStorage.getItem('firstCardAdded') === 'true' 
  //         || localStorage.getItem('previousPath') === '/home' 
  //         || localStorage.getItem('previousPath') === '/' 
  //         || localStorage.getItem('previousPath') === '/privacy'
  //         || localStorage.getItem('cardChanged') === 'true' ){
  //       goTo("/home")
  //     }else{
  //       // goTo(localStorage.getItem('previousPath') || '/home')
  //       window.history.go(-1)
  //     }
  //   }
  // }

  function onClickCloseButton(): void {
    if (disableCloseButton) return;

    if (
      localStorage.getItem('firstCardAdded') === 'true' ||
      localStorage.getItem('previousPath') === '/home' ||
      localStorage.getItem('previousPath') === '/' ||
      localStorage.getItem('previousPath') === '/privacy' ||
      localStorage.getItem('cardChanged') === 'true' ||
      themeChanged
    ) {
      goTo('/home');
    } else {
      window.history.go(-1);
    }
  }



  return (
    <>
    <Toast ref={toast} position="top-center" />
    <div className={`bg-menu-primary menu-style  ${
          isOnline ? "pb-4" : "pb-6"}`} >

      <PopupInstallComponent
        openManually={true}
        showBehaviorManually={showPopupInstall}
        onClosePopup={() => {
          if(showPopupInstall) {
            setShowPopupInstall(false);
          }
        }}
      />

      {
        process.env.REACT_APP_SUFFIX_TITLE_HEADER
        ?

        <div className="flex justify-content-start flex-wrap header-page-menu-no-production">
          <div className="flex align-items-center justify-content-center header-content-menu">
            { process.env.REACT_APP_SUFFIX_TITLE_HEADER }
          </div>
        </div>
        :
        <></>
      }
      {/* <div className="flex justify-content-between flex-wrap m-4"> */}
      {showEditMode ? (
        <div className="flex align-items-center justify-content-between flex-wrap m-3 back-to-menu-style " >
          <div
            className="flex align-items-center ml-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setChangePassword(false);
              setShowEditMode(false);
              setHideChangePassword(false);
              setViewMatchEmail(false);
              setShowFormAddCard(false);
              // localStorage.removeItem("GET_PROFILE_TIME");
              // localStorage.removeItem("profile");
              // getProfile();
            }}
          >
            <i className="pi pi-arrow-left mr-2 font-bold" style={{ fontSize: "1.6rem" }}></i>
            <span>
              Torna al menù
            </span>
          </div>
            
              <div
                className="flex align-items-center justify-content-end font-bold"
                style={{ cursor: "pointer" }}
                
              >
                <i className={ disableCloseButton ? 'hidden' : 'pi pi-times'} style={{ fontSize: "1.9rem" }} onClick={() => {
                  onClickCloseButton();
                }}>
                </i>
              </div>

            </div>
          ) : (
          <>
            <div
              className="flex align-items-center justify-content-end font-bold flex-wrap m-3"
              style={{ cursor: "pointer" }}
              
            >
              <i className={ disableCloseButton ? 'hidden' : 'pi pi-times'} style={{ fontSize: "1.9rem" }} onClick={() => {
                onClickCloseButton()
              }}>
              </i>
            </div>
          </>
        )}
        {/* <div
          className="flex align-items-center justify-content-right font-bold"
          style={{cursor:'pointer'}}
          onClick={() => {
            goTo('/home');
          }}
        >
          <i className="pi pi-times" style={{ fontSize: "1.9rem" }}></i>
        </div> */}
      {/* </div> */}
      <div className="flex align-items-center justify-content-between">
        <div className=" m-2 ml-4 font-bold" style={{ fontSize: "25px" }}>
          {showFormAddCard ? "Aggiungi card" : "Account"}
        </div>
        <div
        // onClick={() => {
        //   setShowEditMode(!showEditMode);
        // }}
        >
          {!showEditMode ? (
            <div
              style={{ cursor: "pointer", color:  'white'  }}
              onClick={() => {
                
                  if(isOnline) {
                    localStorage.removeItem("GET_PROFILE_TIME");
                    localStorage.removeItem("profile");
                  }
                  getProfile();
                  setShowEditMode(true);
                
              }}
            >
              <span className="mr-1" style={{ fontSize: "0.9rem" }}>
                Modifica
              </span>
              <i
                className="mr-4 pi pi-user-edit"
                style={{ fontSize: "1.5rem" }}
              ></i>
            </div>
          ) : (
            // <div
            //   className="flex align-items-center "
            //   style={{cursor:'pointer'}}
            //   onClick={() => {
            //     setChangePassword(false);
            //     setShowEditMode(false);
            //     setHideChangePassword(false);
            //     setViewMatchEmail(false);
            //     setShowFormAddCard(false);
            //     localStorage.removeItem("GET_PROFILE_TIME");
            //     localStorage.removeItem("profile");
            //     getProfile();
            //   }}
            // >
            //   <span
            //     className="mr-1"
            //     style={{ fontSize: "0.9rem", cursor:'pointer' }}
            //   >
            //     Torna al menù
            //   </span>
            //   <i
            //     className="mr-5 pi pi-times-circle"
            //     style={{ fontSize: "1.5rem" }}
            //   ></i>
            // </div>

            <></>
          )}
        </div>
      </div>

      {!showEditMode ? (
        <div
          className="flex flex-column mx-3 mt-1 bg-custom-menu text-white border-round p-2"
          style={{ border: "1px solid white" }}
        >
          <div
            className="flex align-items-center justify-content-left p-1 font-bold"
            style={{ fontSize: "20px" }}
          >
            {user.firstName}
          </div>

          <div
            className="flex align-items-center justify-content-left p-1 font-bold"
            style={{ fontSize: "20px" }}
          >
            {user.lastName}
          </div>

          <div
            className="flex align-items-center justify-content-left p-1 font-bold"
            style={{ fontSize: "15px" }}
          >
            {user.email}
          </div>

          {/* <div
            className="button-change-password flex align-items-center justify-content-center  p-3 mt-3"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setChangePassword(true);
              setShowEditMode(true);
              setHideChangePassword(true);

              setPassword(defaultInfoStatus);
              setMatchPassword(defaultInfoStatus);
            }}
          >
            <i className="pi pi-pencil mr-1" style={{ fontSize: "0.8rem" }}></i>
            CAMBIA PASSWORD

          </div> */}

          <Button
              onClick={() => {
                setChangePassword(true);
                setShowEditMode(true);
                setHideChangePassword(true);
  
                setPassword(defaultInfoStatus);
                setMatchPassword(defaultInfoStatus);
              }}
              
              // disabled={!isOnline}
              className="button-change-password-menu flex align-items-center justify-content-center  p-3 mt-3"
          >
            <i className="pi pi-pencil mr-1" style={{ fontSize: "0.8rem" }}></i>
            CAMBIA PASSWORD
          </Button>

        </div>
      ) : (
        <div
          className="flex flex-column align-items-left justify-content-center mx-4 mt-1 bg-custom-menu text-white border-round p-2 py-4"
          style={{ border: "1px solid white" }}
        >
          {changePassword ? (
            <>
              <form action="" method="post">
              <div
                style={{ fontSize: "20px" }}
                className="mb-5 flex flex-column align-items-center justify-content-center  "
              >
                Cambia Password
              </div>
              <div className="flex  align-items-left justify-content-left ">
                <span className="p-float-label w-full ">
                  <Password
                    className="input-psw-width change-psw-scope"
                    inputRef={ref => ref?.setAttribute('tabIndex','1')}
                    value={password.editValue}
                    onChange={(e) => onChangePassword(e.target.value)}
                    feedback={false}
                    onBlur={() => onBlurPassword()}
                    toggleMask
                    maxLength={MAXLENGTH_PASSWORD}
                  />
                  <label
                    htmlFor="Password"
                    style={{ color: "white" }}
                    className={
                      password.valid || !password.showError
                        ? ""
                        : "text-red-600"
                    }
                  >
                    Nuova Password
                  </label>
                </span>
              </div>
              {password.valid || !password.showError ? (
                <></>
              ) : (
                <div className="flex flex-column">
                  <small>
                    <span className="text-red-600 ">
                      Campo Obbligatorio. Deve contenere minimo 8 caratteri, di
                      cui almeno uno in maiuscolo e un numero
                    </span>
                  </small>
                </div>
              )}

              <div className="flex flex-column mt-4 ">
                <span className="p-float-label w-full mt-3">
                  <Password
                    className="input-psw-width change-psw-scope"
                    inputRef={ref => ref?.setAttribute('tabIndex','2')}
                    value={matchPassword.editValue}
                    onChange={(e) => onChangeMatchPassword(e.target.value)}
                    feedback={false}
                    onBlur={() => onBlurMatchPassword()}
                    toggleMask
                    maxLength={MAXLENGTH_PASSWORD}
                  />
                  <label
                    style={{ color: "white" }}
                    htmlFor="ConfermaPassword"
                    className={
                      matchPassword.valid || !matchPassword.showError
                        ? ""
                        : "text-red-600"
                    }
                  >
                    Conferma Password
                  </label>
                </span>
                {matchPassword.valid || !matchPassword.showError ? (
                  ""
                ) : (
                  <div className="flex flex-column w-12">
                    <small className="text-red-600">
                      <span>{getErrorMatchPassword()}</span>
                    </small>
                  </div>
                )}
              </div>
              <div className="flex align-items-center justify-content-end ">
                <div
                  className="button-undo mx-2 mt-4 flex align-items-center justify-content-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    // setShowEditMode(!showEditMode);
                    // setChangePassword(false);

                    setChangePassword(false);
                    setShowEditMode(false);
                    setHideChangePassword(false);
                  }}
                >
                  ANNULLA
                </div>

                <Button
                  type="submit"
                  onClick={(e) => {
                    e.preventDefault();
                    editPassword();
                  }}
                  label="SALVA"
                  disabled={!isPasswordValid()}
                  style={{ borderRadius: "24px" }}
                  className=" button-edit mx-2 mt-4 flex align-items-center justify-content-center "
                ></Button>
              </div>
              </form>
              <Dialog
                visible={popupSuccessVisible}
                modal={true}
                // header={headerElement}
                footer={footerContent}
                style={{ width: "22rem" }}
                closable={false}
                onHide={() => {
                  setPopupSuccessVisible(false);
                }}
              >
                <p className="m-0">Password cambiata con successo!</p>
              </Dialog>
            </>
          ) : (
            <></>
          )}

          {!hideChangePassword ? (
            <>
              <div
                className="flex flex-column align-items-center justify-content-center mb-5"
                style={{ fontSize: "20px" }}
              >
                Modifica dati account
              </div>

              <div>
                <div className="flex flex-column  my-5">
                  <span className="p-float-label ">
                    <InputText
                      className="edit-mode-input"
                      value={name.editValue}
                      onChange={(e) => {
                        onChangeName(e.target.value);
                      }}
                      invalid={!name.valid && name.showError}
                      onBlur={() => onBlurName()}
                      maxLength={MAXLENGTH_NAME}
                    />
                    <label style={{ color: "white" }} htmlFor="Nome">
                      Nome
                    </label>
                  </span>

                  {name.valid || !name.showError ? (
                    ""
                  ) : (
                    <span>
                      <small className="text-red-600">Campo obbligatorio</small>
                    </span>
                  )}
                </div>

                <div className="flex flex-column mb-6 ">
                  <span className="p-float-label mt-3">
                    <InputText
                      className="edit-mode-input"
                      value={surname.editValue}
                      onChange={(e) => {
                        onChangeSurname(e.target.value);
                      }}
                      invalid={!surname.valid && surname.showError}
                      onBlur={() => onBlurSurname()}
                      maxLength={MAXLENGTH_SURNAME}
                    />
                    <label style={{ color: "white" }} htmlFor="Cognome">
                      Cognome
                    </label>
                  </span>

                  {surname.valid || !surname.showError ? (
                    ""
                  ) : (
                    <span>
                      <small className="text-red-600">Campo obbligatorio</small>
                    </span>
                  )}

                  {!checkCharsNameSurname ? (
                    <span>
                      <small className="text-red-600">
                        La somma di caratteri del nome e del cognome non deve
                        superare i 99 caratteri
                      </small>
                    </span>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="flex flex-column mt-7 mb-5">
                  <span className="p-float-label">
                    <InputText
                      className="edit-mode-input"
                      type="email"
                      value={email.editValue}
                      onChange={(e) => {
                        onChangeEmail(e.target.value);
                      }}
                      invalid={!email.valid && email.showError}
                      onBlur={() => {
                        onBlurEmail();
                      }}
                      keyfilter="email"
                      maxLength={MAXLENGTH_EMAIL}
                    />
                    <label style={{ color: "white" }} htmlFor="Email">
                      Email
                    </label>
                  </span>

                  {email.valid || !email.showError ? (
                    ""
                  ) : (
                    <span>
                      <small className="text-red-600">
                        {" "}
                        {getErrorEmail()}{" "}
                      </small>
                    </span>
                  )}
                </div>
                {viewMatchEmail ? (
                  <>
                    <div className="flex flex-column  mt-4 mb-6">
                      <span className="p-float-label mt-3">
                        <InputText
                          className="edit-mode-input"
                          type="email"
                          value={matchEmail.editValue}
                          onChange={(e) => {
                            onChangeMatchEmail(e.target.value);
                          }}
                          invalid={!matchEmail.valid && matchEmail.showError}
                          onBlur={() => {
                            onBlurMatchEmail();
                          }}
                          keyfilter="email"
                          maxLength={MAXLENGTH_EMAIL}
                        />
                        <label
                          style={{ color: "white" }}
                          htmlFor="ConfermaEmail"
                        >
                          Conferma Email
                        </label>
                      </span>

                      {matchEmail.valid || !matchEmail.showError ? (
                        ""
                      ) : (
                        <span>
                          <small className="text-red-600">
                            {" "}
                            {getErrorMatchEmail()}{" "}
                          </small>
                        </span>
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
              <div className="flex align-items-center justify-content-end  ">
                <div
                  className="button-undo mx-2 mt-1 flex align-items-center justify-content-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowEditMode(!showEditMode);
                    setViewMatchEmail(false);
                    getProfile();
                  }}
                >
                  ANNULLA
                </div>
                {/* <div className="button-edit mx-2 mt-1 flex align-items-center justify-content-center" onClick={()=>editAccountDate()}>
                  SALVA
                </div> */}

                <Button
                  onClick={() => {
                    //setShowEditMode(!showEditMode);
                    editAccountDate();
                    // onSignup();
                    // setVisible(true)
                  }}
                  label="Salva"
                  disabled={!isFormValid()}
                  style={{ borderRadius: "24px" }}
                  className="button-edit mx-2 mt-1 flex align-items-center justify-content-center"
                ></Button>

                {/* <Button
              onClick={() => {
                // onSignup();
                // setVisible(true)
              }}
              label="Annulla"
              //   disabled={!isFormValid()}
              style={{ borderRadius: "24px" }}
              className="button-edit mx-2 mt-4"
            ></Button> */}
              </div>
              <Dialog
                visible={popupSuccessVisible}
                modal={true}
                // header={headerElement}
                footer={footerContent}
                style={{ width: "22rem" }}
                closable={false}
                onHide={() => {
                  setPopupSuccessVisible(false);
                }}
              >
                <p className="m-0">Dati cambiati con successo!</p>
              </Dialog>
            </>
          ) : (
            <></>
          )}

          {showFormAddCard ? (
            <AssociateCard
              Card={{
                groupCode: infoSelectedCard.groupCode,
                storeCode: infoSelectedCard.storeCode,
                selectedCard: selectedCard,
              }}
              OnFinishOperation={(infoOperazione: associateCardOutputModel) => {
                // la rimozione della visualizzazione va fatta indipendentemente
                setShowEditMode(false);
                setChangePassword(false);
                setHideChangePassword(false);
                setShowFormAddCard(false);

                if (infoOperazione.addNewCard) {
                  localStorage.removeItem("cards");
                  localStorage.removeItem("GET_CARDS_TIME");
                  setDisableCloseButton(false)
                  getCards(infoOperazione.storeCodeCheckPrivacy);

                }
              }}
            />
          ) : (
            <></>
          )}
        </div>
      )}

      <div>
        {!showEditMode ? (
          <>
            {cardList.length === 1 ? (
              <>
                <div
                  className="flex align-items-center justify-content-left mt-4 ml-4 font-bold"
                  style={{ fontSize: "25px" }}
                >
                  Fidelity Card
                </div>
                <div
                  className="flex flex-column mx-3 mt-1 bg-custom-menu text-white border-round"
                  style={{ border: "1px solid white" }}
                >
                  <div
                    className="flex align-items-center justify-content-left font-bold"
                    style={{ fontSize: "1rem", padding: "0.75rem 0.75rem" }}
                  >
                    {cardList[0].groupName}
                  </div>
                  {/* <Dropdown 
                            id="cardselector"
                            inputId="cardinputselector"
                            value={selectedCard} 
                            onChange={(e) => onChangeCard(e.value)} 
                            options={cardList} 
                            optionLabel="label" 
                            optionValue='value'  
                            dropdownIcon=" "
                            
                            className="w-full font-bold"
                            itemTemplate={itemTemplate}/> */}
                </div>
              </>
            ) :
            cardList.length === 0
            ?
            (
              <>
                <div className="flex align-items-center justify-content-left mt-4 ml-4 font-bold"
                  style={{ fontSize: "25px" }}>
                  Fidelity Card
                </div>

                <div className="flex flex-column mx-3 mt-1 bg-custom-menu text-white border-round"
                  style={{ border: "1px solid white" }}>

                  <div className="flex align-items-center justify-content-left font-bold nothing-find"
                    style={{ fontSize: "1rem", padding: "0.75rem 0.75rem" }}>
                    Nessuna carta presente
                  </div>

                </div>
              </>
            )
            :
            (
              <>
                <div className="flex justify-content-between align-items-center">
                  <div
                    className=" mt-4 ml-4 font-bold"
                    style={{ fontSize: "25px" }}
                  >
                    Fidelity Card
                  </div>
                  <div className=" mt-4 mr-5 " onClick={() => ShowCard()}>
                    Cambia
                  </div>
                </div>
                <div
                  className= {`   flex justify-content-start align-items-start mx-3 mt-1 bg-custom-menu text-white border-round`} 
                  style={{ border: "1px solid white" }}
                >
                  <Dropdown
                    id="cardselector"
                    inputId="cardinputselector"
                    value={selectedCard}
                    onChange={(e) => onChangeCard(e.value)}
                    options={cardList}
                    optionLabel="storeName"
                    optionValue="value"
                    dropdownIcon="pi pi-arrow-right-arrow-left"
                    className={`w-full font-bold `}
                    // className="w-full font-bold "
                    itemTemplate={itemTemplate}
                    panelClassName={`panelClassSelector `}
                  />
                </div>
              </>
            )}

            {

              cardList.length > 0
              ? 

              <div className="flex flex-column mx-3 mt-1 bg-custom-menu text-white border-round p-2"
                style={{ border: "1px solid white" }}>

                <div className="flex justify-content-between">
                  <div>
                    <div className="flex align-items-center justify-content-center">
                      {loadingGetCustomer ? (
                        <div className="mr-3 flex align-items-center justify-content-center">
                          <span className=" mr-2 ml-1 font-bold">
                            Dati in caricamento . . .
                          </span>
                          <i
                            className="pi pi-spin pi-spinner "
                            style={{ fontSize: "2rem" }}
                          ></i>
                        </div>
                        ) : (
                      ""
                      )}
                  </div>

                  {allProfileInfo?.customerName && !loadingGetCustomer ? (
                    <>
                      <div
                        style={{
                          fontSize: "9px",
                          padding: "3px",
                          fontWeight: "bold",
                        }}
                      >
                        TITOLARE
                      </div>
                      <div
                        style={{ paddingLeft: "3px", fontSize: "15px" }}
                        className="flex align-items-center justify-content-left font-bold"
                      >
                        {allProfileInfo?.customerName}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {allProfileInfo?.mobilePhone && !loadingGetCustomer ? (
                    <>
                      <div
                        className="mt-2"
                        style={{
                          fontSize: "9px",
                          padding: "3px",
                          fontWeight: "bold",
                        }}
                      >
                        CELLULARE
                      </div>
                      <div
                        style={{ paddingLeft: "3px", fontSize: "15px" }}
                        className="flex align-items-center justify-content-left font-bold"
                      >
                        {allProfileInfo?.mobilePhone}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {allProfileInfo?.address && !loadingGetCustomer ? (
                    <>
                      <div
                        className="mt-2"
                        style={{
                          fontSize: "9px",
                          padding: "3px",
                          fontWeight: "bold",
                        }}
                      >
                        INDIRIZZO
                      </div>
                      <div
                        style={{ paddingLeft: "3px", fontSize: "15px" }}
                        className="flex align-items-center justify-content-left font-bold"
                      >
                        {allProfileInfo?.address}
                      </div>
                      <div
                        style={{ paddingLeft: "3px", fontSize: "15px" }}
                        className="flex align-items-center justify-content-left font-bold"
                      >
                        {allProfileInfo?.postalCode +
                          " " +
                          allProfileInfo?.city}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  {
                    (!allProfileInfo && !loadingGetCustomer)
                    ?
                    <div className="flex flex-column">

                      {/* {
                        isOnline
                        ?
                        <></>
                        :
                        <div className='mb-3 flex flex-column '>
                          <img src="./offline_globe.svg" alt=""
                            className="flex align-items-center justify-content-center img-menu-offline-globe-empty-result">
                          </img>
                        </div>
                        
                      } */}

                      <div>Impossibile caricare i dati della card.</div>
                      {
                        isOnline
                        ?
                        <></>
                        :
                        <div>Verifica la connessione internet.</div>
                      }
                    </div>
                    :
                    <></>
                  }
                  {/* <Button className='mt-2' style={{background: 'white', color: '#189cd8', borderColor: 'white'}} label="MODIFICA RECAPITI" icon="pi pi-pencil" iconPos="left"></Button> */}
                </div>
              </div>
            </div>
            : 
            <></>
            }
          

            <div
              className="flex flex-column"
              onClick={() => {
                if(isOnline) {
                  setShowFormAddCard(true);
                  setShowEditMode(true);
                  setHideChangePassword(true);
                }
                else {
                  let message: string = 'Per aggiungere una card, bisogna essere connessi ad internet.';
                  toast.current?.show({ severity: 'error', summary: 'Attenzione', detail: message }); 
                }
              }}
            >
              <div
                // className="flex justify-content-between h-4rem bg-custom-menu text-white border-round font-bold m-3 mb-0 p-3"
                // style={{ border: "1px solid white", cursor: "pointer" }}
                className='flex justify-content-between item-menu bg-custom-menu border-round font-bold'
              >
                <div className="flex justify-content-start align-items-center ">
                  <i
                    className="pi pi-credit-card mr-2"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                  <div className="flex align-items-center justify-content-left">
                    Aggiungi card
                  </div>
                </div>

                <div className="flex align-items-center justify-content-right">
                  <i className="pi pi-plus"></i>
                </div>
              </div>
            </div>

            {/* <div className="flex align-items-center justify-content-left h-4rem bg-custom-menu text-white border-round font-bold m-3 p-3" style={{border: '1px solid white'}}>
                <i className="pi pi-wrench pr-2" style={{ fontSize: '1.5rem' }}></i>
                Impostazioni
            </div> */}

            <div
              className={ 'flex justify-content-between item-menu bg-custom-menu border-round font-bold ' +
                // ((cardList.length > 0 && isOnline) ? '' : 'disable-item-menu')
                ((cardList.length > 0) ? '' : 'disable-item-menu')
              }
              onClick={() => {
                if(cardList.length > 0) {

                  if(isOnline) {
                    updatePrivacy();
                  }
                  else {
                    let message: string = 'Per eseguire l\'aggiornamento dei consensi, bisogna essere connessi ad internet.';
                    toast.current?.show({ severity: 'error', summary: 'Attenzione', detail: message });
                  }

                }
              }}
            >
              <div className="flex justify-content-start align-items-center ">
                <i
                  className="pi pi-lock mr-2"
                  style={{ fontSize: "1.5rem" }}
                ></i>
                <div className="flex align-items-center justify-content-left">
                  Consensi
                </div>
              </div>

              <div className="flex align-items-center justify-content-right">
                <i className="pi pi-pencil"></i>
              </div>
            </div>

            <div className=" ">
              <div
                className="bg-custom-menu font-bold text-white border-round m-3 "
                style={{ border: "1px solid white" }}
              >
                <div
                  className="flex align-items-center justify-content-between p-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowLegalInfo(!showLegalInfo);
                  }}
                >
                  <div
                    className="flex align-items-center justify-content-left font-bold"
                    style={{ fontSize: "14px" }}
                  >
                    <i
                      className="pi pi-file-pdf pr-2"
                      style={{ fontSize: "1.5rem" }}
                    ></i>
                    Informazioni Legali
                  </div>
                  {showLegalInfo ? (
                    <>
                      <i className="pi pi-arrow-down"></i>
                    </>
                  ) : (
                    <>
                      <i className="pi pi-arrow-right"></i>
                    </>
                  )}
                </div>

                {showLegalInfo ? (
                  // <ScrollPanel style={{ width: '100%', height: historyPoints.length > 0 ? '200px' : '46px', border: '1px solid #189cd8', borderTop: '0px' }} className="mt-1">
                  <div
                    className="flex justify-content-start bg-custom-menu pl-3"
                    style={{ color: "white" }}
                  >
                    <ul className="flex flex-column  align-items-start ">
                      <div className="flex align-items-start justify-content-center ">

                        {
                          cardList.length > 0
                          ?
                          <li className="mb-3" style={{ cursor: "pointer" }}
                            onClick={() => { downloadPdfPrivacy(); }}>

                            Informativa privacy
                          </li>
                          :
                          <></>
                        }
                       
                        {loadingGetPdfPrivacy ? (
                          <div className="relative ml-2">
                            <i
                              className="pi pi-spin pi-spinner"
                              style={{ fontSize: "0.8rem" }}
                            ></i>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <li
                        className="mb-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowCondizioniUtilizzo(true)}
                      >
                        Termini di utilizzo
                      </li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>

            <div
              className="flex justify-content-between h-4rem bg-custom-menu text-white border-round font-bold m-3 p-3"
              style={{ border: "1px solid white", cursor: "pointer" }}
              onClick={() => setShowSharingComponent(true)}
            >
              <div className="flex justify-content-start align-items-center ">
                <i
                  className="pi pi-share-alt mr-2"
                  style={{ fontSize: "1.5rem" }}
                ></i>
                <div className="flex align-items-center justify-content-left">
                  Condividi
                </div>
              </div>

              <div className="flex align-items-center justify-content-right">
                <i className="pi pi-arrow-right"></i>
              </div>
            </div>

            <div className=" ">
              <div
                className="bg-custom-menu font-bold text-white border-round m-3 "
                style={{ border: "1px solid white" }}
              >
                <div
                  className="flex align-items-center justify-content-between p-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setShowConfig(!showConfig);
                  }}
                >
                  <div
                    className="flex align-items-center justify-content-left font-bold"
                    style={{ fontSize: "14px" }}
                  >
                    <i
                      className="pi pi-cog pr-2"
                      style={{ fontSize: "1.5rem" }}
                    ></i>
                    Impostazioni
                  </div>
                  {showConfig ? (
                    <>
                      <i className="pi pi-arrow-down"></i>
                    </>
                  ) : (
                    <>
                      <i className="pi pi-arrow-right"></i>
                    </>
                  )}
                </div>

                {showConfig ? (
                  // <ScrollPanel style={{ width: '100%', height: historyPoints.length > 0 ? '200px' : '46px', border: '1px solid #189cd8', borderTop: '0px' }} className="mt-1">
                  <div
                    className="flex justify-content-start bg-custom-menu  pb-2"
                    style={{ color: "white" }}
                  >
                    <ul style={{listStyleType: 'none'}} >
                      <li className="flex align-items-center" onClick={() => setShowThemeSelector(true)}>
                        <i className=" bi bi-brush mr-1" style={{ fontSize: "1.5rem" }}></i> 
                        <div>Cambia Tema</div>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>

            {pwaInstalled() === false ?
              <div
                id='installButton'
                className="flex justify-content-between h-4rem bg-custom-menu text-white border-round font-bold m-3 p-3"
                style={{ display: 'none !important', border: "1px solid white", cursor: "pointer" }}
                onClick={() => onClickInstallButton(setShowPopupInstall) }
              >
                <div className="flex justify-content-start align-items-center ">
                  <i
                    className="pi pi-download mr-2"
                    style={{ fontSize: "1.5rem" }}
                  ></i>
                  <div className="flex align-items-center justify-content-left">
                    Installa
                  </div>
                </div>

                <div className="flex align-items-center justify-content-right">
                  <i className="pi pi-download"></i>
                </div>
              </div>
              : <></>
            }


            {showCondizioniUtilizzo ? (
              <Dialog
                header="Informativa privacy"
                modal={true}
                blockScroll={true}
                dismissableMask={true}
                visible={showCondizioniUtilizzo}
                className="panel-class-dialog-privacy"
                onHide={() => setShowCondizioniUtilizzo(false)}
                position="bottom"
                draggable={false}
                style={{ width: "95%", maxWidth: "500px" }}
              >
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                  <Viewer
                    fileUrl="Informativa_privacy.pdf"
                    defaultScale={SpecialZoomLevel.PageWidth}
                    viewMode={ViewMode.SinglePage}
                    renderLoader={() => <LoadingSpinner show={true} />}
                    renderError={(error: LoadError) => renderErrorViewerPdf()}
                  />
                </Worker>
              </Dialog>
            ) : (
              <></>
            )}

            {/* <div className="flex align-items-center justify-content-right">
                    {
                        loadingGetPdfPrivacy 
                        ?
                        <div className="relative">
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                        </div>
                        :
                        ''
                    }
                  </div> */}
            {/* </div> */}
            <div className="flex lign-items-center justify-content-center ">
              <div
                className=" button-exit-menu flex align-items-center justify-content-center font-bold mt-1 p-3 mb-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  exitFromApplication();
                }}
              >
                <i
                  className="pi pi-power-off pr-2"
                  style={{ fontSize: "1.5rem" }}
                ></i>
                Logout
              </div>
            </div>

            {showSharingComponent ? (
              <Dialog
                header="CONDIVIDI L'APP"
                focusOnShow={false}
                modal={true}
                blockScroll={true}
                dismissableMask={true}
                visible={showSharingComponent}
                style={{ width: "95%", maxWidth: "500px" }}
                draggable={false}
                onHide={() => setShowSharingComponent(false)}
              >
                <ShareComponent></ShareComponent>
              </Dialog>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </div>
      {showThemeSelector && (
      <Dialog
          key={dialogKey} // La chiave cambia ad ogni apertura
          header="Seleziona Tema"
          visible={true}
          style={{ width: '70%' }}
          onHide={() => setShowThemeSelector(false)}
          contentClassName={`theme-${theme}`}
          headerClassName={`theme-${theme}`}
      >
        <div className="theme-options flex flex-column align-items-center justify-content-center">
          <div className="theme-pair flex flex-column align-items-center justify-content-center" style={{  width:'70%' }}>
                <div className={`container-preview-theme ${theme === 'light-blue' ? 'is-selected' : ''} " `} 
                data-theme="light-blue"
                  aria-selected={theme === 'light-blue'}
                  role="option"
                  tabIndex={0}
                  onClick={() => handleThemeChange("light-blue")}>
                  <span className="theme-check-badge" aria-hidden="true">
                    <i className="pi pi-check" />
                  </span>
                  <div className="light-blue-header-preview-theme"></div>
                  <div className="light-blue-subheader-preview-theme"></div>
                  <div className="light-blue-body-preview-theme">CHIARO</div>
                  <div className="light-blue-footer-preview-theme"></div>
                </div>


                <div className={`container-preview-theme ${theme === 'dark' ? 'is-selected' : ''} " `} 
                data-theme="dark"
                  aria-selected={theme === 'dark'}
                  role="option"
                  tabIndex={0}
                  onClick={() => handleThemeChange("dark")}>
                  <span className="theme-check-badge" aria-hidden="true">
                    <i className="pi pi-check" />
                  </span>
                  <div className="notte-preview-header"></div>
                  <div className="notte-preview-subheader"></div>
                  <div className="notte-preview-body">NOTTE</div>
                  <div className="notte-preview-footer"></div>
                </div>
                
                <div className={`container-preview-theme ${theme === 'high-contrast' ? 'is-selected' : ''} " `} 
                data-theme="high-contrast"
                  aria-selected={theme === 'high-contrast'}
                  role="option"
                  tabIndex={0}
                  onClick={() => handleThemeChange("high-contrast")}>
                  <span className="theme-check-badge" aria-hidden="true">
                    <i className="pi pi-check" />
                  </span>
                  <div className="alto-contrasto-preview-header"></div>
                  <div className="alto-contrasto-preview-subheader"></div>
                  <div className="alto-contrasto-preview-body">
                    <div className="alto-contrasto-body-text">ALTO</div>
                    <div className="alto-contrasto-body-text">CONTRASTO</div>                    
                  </div>
                  <div className="alto-contrasto-preview-footer"></div>
                </div>
            </div>
        </div>

      </Dialog>
      )}
        {/* L' ho nascondo in maniera tale che l' icona viene sempre caricata */}
        {/* <div className={ 'flex flex-column ' + (isOnline ? 'opacity-0' : 'opacity-100 banner-menu-no-connection ') }>
          <div className="flex align-items-center justify-content-center">
            <i className='bi bi-cloud-slash mr-2' style={{ fontSize: '1rem' }}></i>
            <span className='font-footer'>Nessuna connessione</span>
          </div>

          <div className="flex align-items-center justify-content-center">
            <span className='font-footer'>
              Alcune funzionalità non sono disponibili senza connessione.
            </span>
          </div>

        </div>

        {
          showReturnOnline
          ?
          <div className="flex flex-column banner-menu-reconnection">
            <div className="flex align-items-center justify-content-center">
              <i className='bi bi-globe-americas mr-2' style={{ fontSize: '1rem' }}></i>
              <span className='font-footer-return-online'>Sei di nuovo Online</span>
            </div>
          </div>
          :
          <></>
        } */}
      
    </div>
    </>
  );
}
